import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a9b079e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex gap-5 justify-content-center py-6" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "type-card-label" }
const _hoisted_4 = { class: "type-card-desc" }

import { EventTypes } from "@/core/types/shop/ShopEventRoles";


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectEventType',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any) {




const descriptions: Record<number, string> = {
  0: "Standard event with terms, instructions, and images",
  1: "Popup event with images, no terms or instructions",
  2: "Header banner event, content only",
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(EventTypes), (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.value,
        class: _normalizeClass(["type-card", { active: _ctx.modelValue === item.value }]),
        onClick: ($event: any) => (_ctx.$emit('update:modelValue', item.value))
      }, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(item.label), 1),
        _createElementVNode("div", _hoisted_4, _toDisplayString(descriptions[item.value]), 1)
      ], 10, _hoisted_2))
    }), 128))
  ]))
}
}

})